import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const SITE_ID = process.env.REACT_APP_SITE_ID || 'docksidedesign';

const api = axios.create({
  baseURL: `${API_URL}/${SITE_ID}`,
  headers: { 'Content-Type': 'application/json' },
});

// Separate instance for non-site-scoped endpoints (e.g. /health)
const rootApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// --- Health ---
export const getHealth = () => rootApi.get('/health').then(r => r.data);

// --- Public ---
export const submitBooking = (data) => api.post('/bookings', data);
export const subscribeEmail = (email) => api.post('/emails', { email });
export const getEvents = () => api.get('/events').then(r => r.data);
export const getMenu = () => api.get('/menus').then(r => r.data);
export const submitContact = (data) => api.post('/contact', data);

// --- Blog (public) ---
export const fetchPosts = () => api.get('/posts').then(r => r.data);
export const fetchPost = (slug) => api.get(`/posts/${slug}`).then(r => r.data);

// --- Admin (requires API key) ---
const adminApi = (apiKey) => axios.create({
  baseURL: `${API_URL}/${SITE_ID}`,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
  },
});

export const listBookings = (apiKey) => adminApi(apiKey).get('/bookings').then(r => r.data);
export const listSubscribers = (apiKey) => adminApi(apiKey).get('/emails').then(r => r.data);
export const listEvents = (apiKey) => adminApi(apiKey).get('/events').then(r => r.data);

export { API_URL, SITE_ID };
